var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from 'styled-components';
export var cardStyles = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  background: ", ";\n"], ["\n  ", ";\n  ", ";\n  background: ", ";\n"])), function (props) { return props.theme.elevation.base.elevation1; }, function (props) { return props.theme.borders.base; }, function (props) { return props.theme.colors.bg.body; });
var templateObject_1;
